import PWDService from './apiClient';

async function ccbLogWorker(fieldActivity) {
    console.log("running ccbLogWorker for faId: ", fieldActivity.FieldActivityId);
    let seqNum = 0;
    seqNum = fieldActivity.LastLogSequenceNumber;
    seqNum += 1;

    return PWDService.postToFieldActivityLog(fieldActivity.FieldActivityId, seqNum, fieldActivity.LogMessage);

}

export { ccbLogWorker };